import { connect } from 'react-redux';
import { compose } from 'redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';
import type { HomeItem, HomePrescriptionItem, StrictUnion } from 'src/app/types';

import { AnimatedMedications } from '../AnimatedMedications';
import { PatientAccordion } from '../PatientAccordion';

type GroupedMedicationProps =
  | {
      hasMultiplePatients: boolean;
      showNoActiveMedications: boolean;
      homescreenItemsByPatient: HomeItem[];
    }
  | {
      pendingItems: HomePrescriptionItem[];
      showPendingText: boolean;
      handleOpenLiveChat?: () => void;
    };

const _GroupedMedications = ({
  hasMultiplePatients,
  homescreenItemsByPatient,
  showNoActiveMedications,
  pendingItems,
  showPendingText,
}: StrictUnion<GroupedMedicationProps>) => {
  if (pendingItems && pendingItems.length > 0) {
    return (
      <AnimatedMedications
        prescriptionItems={pendingItems}
        showPendingText={showPendingText}
        isPendingTransfers
        hasMultiplePatients={false}
        showNoActiveMedications={false}
      />
    );
  }

  if (!hasMultiplePatients) {
    return (
      <>
        {homescreenItemsByPatient?.map(({ patient, items }) => (
          <AnimatedMedications
            key={patient.id}
            hasMultiplePatients={false}
            prescriptionItems={items}
            showNoActiveMedications={showNoActiveMedications}
          />
        ))}
      </>
    );
  }

  return (
    <PatientAccordion
      hasMultiplePatients
      showNoActiveMedications={showNoActiveMedications}
      items={homescreenItemsByPatient}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchSegmentTrack: (event: UnifiedEvent, payload: Record<string, any>) => dispatch(segmentTrack(event, payload)),
});

export const GroupedMedications = compose(connect(null, mapDispatchToProps))(_GroupedMedications);
